import { AddReactionFeedbackToChatMessageDefinition } from "@super-real/types";
import { getCallable } from "../../Firebase/helpers/getCallable";

export const addReactionFeedbackToChatMessageCallable = getCallable(
  AddReactionFeedbackToChatMessageDefinition
);
